export default "__VITE_ASSET__187c5985__"